/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import { fetchGondolas } from './graphqlService'

const extractGondolas = (data) =>
  data?.data?.connectGondolaList?.items ||
  data?.data?.gondolaList?.items ||
  []

export const gondolaService = {
  getGondolas: async (schedulePath = null) => {
    const data = await fetchGondolas(schedulePath)
    return extractGondolas(data)
  },
}
